import restApiDispatcher from "@/store/utils/api-dispatcher";
import { Payment } from "@/models";

const getPaymentPlans = (context, params) =>
  restApiDispatcher(context, {
    resource: Payment,
    storeKey: "paymentPlans",
    loadingKey: "paymentPlansLoading",
    action: "getPaymentPlans",
    commitType: "randomObjectWrappedIndex",
    params
  });

const getClubPaymentPlans = (context, params) =>
  restApiDispatcher(context, {
    resource: Payment,
    storeKey: "paymentPlans",
    loadingKey: "paymentPlansLoading",
    action: "getPaymentPlansClub",
    commitType: "randomObjectWrappedIndex",
    params
  });

const getAthletePaymentPlans = (context, params) =>
  restApiDispatcher(context, {
    resource: Payment,
    storeKey: "paymentPlans",
    loadingKey: "paymentPlansLoading",
    action: "getPaymentPlansAthlete",
    commitType: "randomObjectWrappedIndex",
    params
  });

const paypalPaymentNormal = (context, params) =>
  restApiDispatcher(context, {
    resource: Payment,
    storeKey: "payment",
    loadingKey: "paymentLoading",
    action: "paypalPaymentNormal",
    commitType: "show",
    message: `Profile upgraded ${
      params.uSlug === "ClubCoach"
        ? ""
        : ", select the profile from profile list page to use all the new features."
    }`,
    params
  });

const paypalPromoCodePayment = (context, params) =>
  restApiDispatcher(context, {
    resource: Payment,
    storeKey: "payment",
    loadingKey: "paymentLoading",
    action: "paypalPayment",
    commitType: "show",
    message: `Profile upgraded ${
      params.uSlug === "ClubCoach"
        ? ""
        : ", select the profile from profile list page to use all the new features."
    }`,
    params
  });

const createPaymentHistory = (context, params) =>
  restApiDispatcher(context, {
    resource: Payment,
    storeKey: "paymentHistory",
    loadingKey: "paymentHistoryLoading",
    action: "createPaymentHistory",
    commitType: "show",
    params
  });

const checkPromoCode = (context, params) =>
  restApiDispatcher(context, {
    resource: Payment,
    storeKey: "promoCode",
    loadingKey: "promoCodeLoading",
    action: "promoCodeCheck",
    commitType: "show",
    message: "Promo code applied",
    params
  });

const promoCodeValidation = (context, params) =>
  restApiDispatcher(context, {
    resource: Payment,
    storeKey: "promoCodeValidation",
    loadingKey: "promoCodeLoading",
    action: "promoCodePaymentValidation",
    commitType: "show",
    message: "Promo code verified",
    params
  });

const paymentHistories = (context, params) =>
  restApiDispatcher(context, {
    resource: Payment,
    storeKey: "paymentHistories",
    loadingKey: "paymentHistoriesLoading",
    action: "paymentHistories",
    commitType: "indexUnwrapped",
    params
  });

const initializePayment = (context, params) =>
  restApiDispatcher(context, {
    resource: Payment,
    storeKey: 'initializePayment',
    loadingKey: 'paymentLoading',
    action: 'initializePayment',
    commitType: 'show',
    params
  })

const clearPromoCode = context => context.commit("CLEAR_PROMO_CODE");

const clearPaymentHistory = context => context.commit("CLEAR_PAYMENT_HISTORY");

export default {
  getPaymentPlans,
  paypalPaymentNormal,
  paypalPromoCodePayment,
  createPaymentHistory,
  checkPromoCode,
  clearPromoCode,
  promoCodeValidation,
  paymentHistories,
  getClubPaymentPlans,
  getAthletePaymentPlans,
  clearPaymentHistory,
  initializePayment
};
